import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useMutationDeleteComment } from '../mutations/useMutationDeleteComment.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { getUserColorFromId } from '@fabric-app/utils/color';
import { mediaHover, mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { Conversation } from '@fabric-app/ui/components/Conversation';
import { SimplifiedIconDotMenu, DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useResourceDataContextSafe } from '../../resource-detail/components/context/resourceDataContext.js';
import AvatarUser from '../../user/components/AvatarUser/AvatarUser.js';
import { IconPencil, IconTrash } from '@fabric-app/icons/svg';

const CommentComponent = ({ comment, resourceId, onEdit }) => {
  const { data: user } = useQueryUserInfo();
  const { disabledActions } = useResourceDataContextSafe();
  const mutationDeleteComment = useMutationDeleteComment();
  const deleteHandler = async () => {
    if (typeof comment === "string") return;
    mutationDeleteComment.mutate({
      resourceId,
      commentId: comment.id
    });
  };
  const owner = typeof comment === "string" ? {
    name: user?.name ?? "",
    pictureUrlCdn: user?.pictureUrlCdn || void 0,
    color: getUserColorFromId(user?.id ?? "")
  } : comment.user ? {
    name: comment.user.name || "",
    pictureUrlCdn: comment.user.pictureUrlCdn || void 0,
    color: getUserColorFromId(comment.user.id)
  } : {
    name: "Deleted user"
  };
  const canManageComment = !disabledActions.manageOthersComments || !disabledActions.addOrEditOwnComment && comment.user?.id === user?.id;
  return /* @__PURE__ */ jsxs(CommentWrapper, {
    "data-testid": "comment",
    children: [
      /* @__PURE__ */ jsxs(Conversation.ItemHeader, {
        children: [
          /* @__PURE__ */ jsx(AvatarUser, {
            user: owner,
            size: 24,
            color: owner.color
          }),
          /* @__PURE__ */ jsx(Conversation.ItemHeaderName, {
            children: owner.name
          }),
          typeof comment === "object" && !comment.isDraft && canManageComment && /* @__PURE__ */ jsxs(DropdownMenu, {
            renderTriggerElement: ({ onOpenChange, open }) => /* @__PURE__ */ jsx(DropdownButton, {
              as: DropdownMenu.Trigger,
              onOpenChange,
              open
            }),
            children: [
              /* @__PURE__ */ jsx(DropdownMenu.Group, {
                children: /* @__PURE__ */ jsx(DropdownMenu.Item, {
                  iconElement: /* @__PURE__ */ jsx(IconPencil, {}),
                  onClick: onEdit,
                  "data-testid": "comment-edit-button",
                  disabled: comment.user?.id !== user?.id,
                  children: "Edit"
                })
              }),
              /* @__PURE__ */ jsx(DropdownMenu.Group, {
                children: /* @__PURE__ */ jsx(DropdownMenu.Item, {
                  iconElement: /* @__PURE__ */ jsx(IconTrash, {}),
                  variant: "danger",
                  onClick: deleteHandler,
                  "data-testid": "comment-delete-button",
                  children: "Delete"
                })
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsx(Conversation.ItemBody, {
        markdown: comment.content,
        "data-or-obscured": true
      })
    ]
  });
};
const DropdownButton = styled(SimplifiedIconDotMenu).withConfig({
  displayName: "Comment__DropdownButton",
  componentId: "sc-bad34fdf-0"
})([
  `width:1.625rem;height:1.25rem;background:transparent;overflow:visible;svg{rotate:90deg;scale:0.65;color:white;}&:before{content:'';display:block;width:2rem;height:2rem;position:absolute;}`,
  `{&:hover{background:rgba(255,255,255,0.1);}}opacity:0;`,
  `{opacity:1;height:1rem;}`,
  ``
], mediaHover, mediaMobile, (p) => p.open && "opacity: 1;");
const CommentWrapper = styled(Conversation.Item).withConfig({
  displayName: "Comment__CommentWrapper",
  componentId: "sc-bad34fdf-1"
})([
  ``,
  `{&:hover{`,
  `{opacity:1;}}}`
], mediaHover, DropdownButton);

export { CommentComponent as default };
//# sourceMappingURL=Comment.js.map
